import React from 'react';
import AboutComponent from '../components/AboutCard'
import AIWeb from '../resources/AI in web image.svg'
import desktop from '../resources/laptop coffee.svg'
import projects from '../resources/projects.jpg'
function About(props) {
    return (
        <div id='about' className='grid grid-cols-2 max-md:grid-cols-1 gap-8 text-white py-[100px]'>
            <AboutComponent image={AIWeb}   text="I design and build data-driven systems that turn complex problems into scalable solutions" gradient="from-purple-#8E2DE2  to-cyan-#4A00E0"/>
            <AboutComponent image={desktop} reverse={true} text="Delivering robust, production-ready solutions with a focus on performance and detail" gradient="from-blue-#00c6ff to-blue-#0072ff"/>
            <AboutComponent image={projects}  text="From data pipelines to deployed models — I build end-to-end machine learning systems" gradient="from-indigo-#4568DC to-blue-#B06AB3"/>
            <AboutComponent image={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSwWHwF5Al8GjadzMbbt4TVtdUgUk7IdqVzMw&s"} reverse={true} text="Collaborating to turn concepts into real systems — from idea to deployment" gradient="from-indigo-#4568DC to-blue-#B06AB3"/>

        </div>
    );
}

export default About;